import { type EditorPlugin } from '../../types/aha-editor';

const EmbeddedReportSchemaPlugin: EditorPlugin = {
  name: 'Embedded report schema',
  schema: {
    'embedded-report': {
      isVoid: true,
      isInline: true,
    },
    'embedded-report-placeholder': {
      isVoid: true,
      isInline: true,
    },
  },
};

export default EmbeddedReportSchemaPlugin;
